const libraryRouter = [
  {
    path: '/live/preview/:id(\\d+)',
    name: 'LivePreview',
    component: () => import('@/views/live/preview')
  },
  {
    path: '/live/:id(\\d+)',
    name: 'LiveDetail',
    component: () => import('@/views/live/detail')
  },
  {
    path: '/live/apply/:id(\\d+)',
    name: 'LiveApply',
    component: () => import('@/views/live/apply')
  }
]
export default libraryRouter



// WEBPACK FOOTER //
// ./src/router/modules/live.js